import customHeaders, { getSpace } from '../../common/headers';
import add_icon from './img/add_icon.svg';
import refresh_icon from './img/refresh_icon.svg';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchWarehouseFilter } from '../../common/filtersFunc';
import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { fetchFilterV3 } from '../../common/filtersFunc';
import {
  Tabs,
  ButtonBasic,
  TableBox,
  DropDownSelector,
  SearchComponent,
} from '@lk-gtcom/ecomlab-components';
import {
  KonstantinCreateProductHttps,
  KonstantinMasterHttps,
  OlegHttps,
} from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import './SetRemainingGoodMasterProduct.scss';
import { ModalRules } from '../../components/Modal/ModalRules/ModalRules';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  { label: 'Установка остатков', value: 'setting-balances' },
  { label: 'Правила установки остатков', value: 'rules' },
];

const SetRemainingGoodMasterProduct = () => {
  const activeTab = useParams()['*'];
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'set-remaining-good-master-product');
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const location = useLocation();
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  const [pageValue, setPageValue] = useState(activeTab || 'setting-balances');

  // Фильтр
  const filterConfig = [
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
    { key: 'search', type: 'single' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [warehouseData, setWarehouseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedWarehouse, setSelectedWarehouse] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [warehousePage, setWarehousePage] = useState(1);
  const [warehouseQuery, setWarehouseQuery] = useState('');

  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);
  const [totalWarehouse, setTotalWarehouse] = useState(0);

  // Поиск
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [defaultSearchValue, setDefaultSearchValue] = useState('')

  const [checkedProducts, setCheckedProducts] = useState([]);

  const [isModal, setIsModal] = useState(false);
  const service_id = 3;
  const [rule_id, setRuleId] = useState(1);
  const [ruleInfo, setRuleInfo] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [ruleName, setRuleName] = useState('');

  const [date, setDate] = useState(periodWeek());

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const [dateFrom, dateTo] = date;
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { loading, sort } = tableProps;
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const { total } = tableProps;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.warehouse) setSelectedWarehouse(urlParams.warehouse)
        if (urlParams.search) {
          setSearchValue(urlParams.search?.value)
          setDefaultSearchValue({
            value: urlParams.search?.value,
            label: urlParams.search?.label
          })
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      warehouse: urlParams?.warehouse || selectedWarehouse
    })
  }, []);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab, isReady]);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `${KonstantinMasterHttps}/master-products/tables/stocks${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    let offer_id_name_search = searchValue;



    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        setTable(json);
      })
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
    let url = `${KonstantinMasterHttps}/master-products/filters/offer-id-name`;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setSearchData(json?.filter_data?.map(({ id, name }) => ({ label: name, value: id }))))
      .catch(handleRequestError);
  };

  const fetchUpdateStock = (abortController = new AbortController()) => {
    let url = `${KonstantinCreateProductHttps}/master_products/stocks`;

    const stocks = checkedProducts?.map((el) => {
      const { product_id, Артикул } = el;

      return {
        product_id,
        offer_id: Артикул,
        stock: el?.['Остаток на ваших складах'],
      };
    });

    const body = JSON.stringify({
      stocks,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        const abortController = new AbortController();
        fetchTableData([], abortController);
        return () => abortController.abort();
      })
      .catch(handleRequestError);
  };

  const fetchUpdateOneStock = (productId, offerId, stock, setStatus) => {
    let url = `${KonstantinCreateProductHttps}/master_products/stocks`;

    const stocks = [
      {
        product_id: productId,
        offer_id: offerId,
        stock: stock,
      },
    ];
    const body = JSON.stringify({
      stocks,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        console.log(json);
        // const abortController = new AbortController();
        // fetchTableData([], abortController);
        // return () => abortController.abort();
      })
      .catch((err) => {
        setStatus('error');
        handleRequestError(err);
      });
  };

  const fetchTableRules = (params) => {
    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }

    const url = `${OlegHttps}/api/v1/${service_id}/client_rule/table`;

    setLoading(true);

    const body = JSON.stringify({
      filters,
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        setTable(json);
        setTableUrl(url);
        setTableBody(body);
        setLoading(false);
      })
      .catch(handleRequestError)
      .finally(() => {
        setLoading(false);
      });
  };

  const filtersMasterCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersMasterBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  const filtersWarehouse = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchWarehouseFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: warehousePage,
      categoryData,
      selectedCategory,
      selectedBrand,
      brandData,
      dateFrom,
      dateTo,
      searchParam: warehouseQuery,
      setTotal: setTotalWarehouse,
      setWarehouseData: (e) => setWarehouseData(e),
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersWarehouse()
  }, [isFilterRequest, date, warehousePage, warehouseQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterCategory()
  }, [isFilterRequest, date, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersMasterBrand()
  }, [isFilterRequest, date, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const onActionHandler = (prop) => {
    const name = prop?.['Название правила'];
    const status = prop?.['Статус'];
    const rule_id = prop?.Rule_id?.[0];
    setRuleInfo({ name, status, rule_id, isEdit: true, isCreate: false });
    setIsModal(true);
  };

  useEffect(() => {
    if(!isReady) return
    const abortController = new AbortController();
    resetTable();
    if (pageValue === 'setting-balances') {
      fetchTableData([], abortController);
    } else {
      fetchTableRules();
    }
    return () => abortController.abort();
  }, [pageValue, isTableRequest]);

  const handleSearch = useCallback((e) => {
    const abortController = new AbortController();
    fetchSearch(e, abortController);
    return () => abortController.abort();
  });

  const handleSaveOneRemainder = (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const productId = actionEvent[0]?.product_id;
    const offerId = inputEvent?.id[0];
    const stock = +inputEvent?.value;
    if (productId && offerId && stock) {
      setStatus('loading');
      fetchUpdateOneStock(productId, offerId, stock, setStatus);
    } else {
      setStatus('error');
    }
  };

  const handleSaveSuccess = () => {
    fetchTableRules();
  };

  return (
    <>
      {isModal && (
        <ModalRules
          isEdit={isEdit}
          setIsEdit={(e) => setIsEdit(false)}
          isCreate={!isEdit}
          {...ruleInfo}
          rule_id={rule_id}
          setRuleIdPar={setRuleId}
          ruleName={ruleName}
          service_id={service_id}
          setRuleInfo={(e) => setRuleInfo(e)}
          setIsModal={setIsModal}
          handleSaveSuccess={handleSaveSuccess}
        />
      )}

      <div className="set-remaining-goods-master-product">
        <TitlePage
          title='Установка остатков'
        />

        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
          onReset={(e) => {
            setSelectedWarehouse([]);
            setSelectedCategory([]);
            setSelectedBrand([]);
            setSearchValue('')
            setSearchData([])
            updateURL({
              warehouse: null,
              category: null,
              brand: null,
              offerId: null,
              search: null
            });
            setIsTableRequest(!isTableRequest)
            setIsFilterRequest(!isFilterRequest)
          }}
        >
          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={(e) => {
              updateURL({ category: selectedCategory });
              filtersMasterBrand()
              filtersWarehouse()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={() => {
              updateURL({ brand: selectedBrand });
              filtersWarehouse()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={warehouseData}
            state={selectedWarehouse}
            setState={setSelectedWarehouse}
            fetchCallback={setWarehousePage}
            setInputChange={setWarehouseQuery}
            placeholder="Склад"
            total={totalWarehouse}
            multi
            onBlur={() => {
              updateURL({ warehouse: selectedWarehouse });
              setIsTableRequest(!isTableRequest)
            }}
          />

          {pageValue != 'rules' && (
            <SearchComponent
              searchValue={searchValue}
              errSearch={false}
              placeholder="Искать по артикулу или названию"
              errText="Неверный артикул или название"
              setSearchValue={setSearchValue}
              fetchData={(e) => setIsTableRequest(!isTableRequest)}
              fetchCallback={fetchSearch}
              data={searchData}
              onClearDependence={[isFilterRequest]}
              updateURL={updateURL}
              value={defaultSearchValue}
            />
          )}
        </FilterContainer>

        <div className="toolbar-medium">
          <Tabs
            tabs={btn_tab}
            pageValue={pageValue}
            query={location?.search}
          />
        </div>

        {pageValue !== 'rules' ? (
          <TableBox
            {...tableProps}
            paginator={true}
            ref={paginatorRef}
            onCheck={(e) => setCheckedProducts(e)}
            fetchCallback={fetchTableData}
            tableUrl={tableUrl}
            tableBody={tableBody}
            onInputAction={(e) => {
              handleSaveOneRemainder(e);
            }}
            child={<ButtonBasic
              violet
              //   disabled={isDisabledBtn}
              icon={pageValue != 'rules' ? refresh_icon : add_icon}
              text={pageValue != 'rules' ? 'Обновить остатки' : 'Добавить правило'}
              onClick={(e) => {
                if (pageValue == 'rules') {
                  setIsModal(true);
                } else {
                  fetchUpdateStock()
                }
              }}
              width="auto"
              size="32px"
            />}
          />
        ) : (
          <TableBox
            tableUrl={tableUrl}
            tableBody={tableBody}
            onAction={(e) => {
              const ruleId = e['Идентификатор правила']
                ? e['Идентификатор правила']
                : null;
              onActionHandler(e);
              setRuleId(Number(ruleId));
            }}
            ref={paginatorRef}
            paginator={true}
            fetchCallback={(e) => fetchTableRules(e)}
            {...tableProps}
            statistic={[
              {
                label: 'Правил',
                sum: total,
              },
            ]}
            child={<ButtonBasic
              violet
              //   disabled={isDisabledBtn}
              icon={pageValue != 'rules' ? refresh_icon : add_icon}
              text={pageValue != 'rules' ? 'Обновить остатки' : 'Добавить правило'}
              onClick={(e) => {
                if (pageValue == 'rules') {
                  setIsModal(true);
                } else {
                  fetchUpdateStock()
                }
              }}
              width="auto"
              size="32px"
            />}
          />
        )}
      </div>
    </>
  );
};

export { SetRemainingGoodMasterProduct };
